import React from 'react';
import styled from 'styled-components/macro';

const TimesSelectNoStyle = ({
  children,
  error,
  ...otherProps
}) => (
  <select data-recording-gdpr-safe {...otherProps}>
    {children}
  </select>
);
export default styled(TimesSelectNoStyle)`
  border: 1px solid ${({ theme }) => theme.colors.colorGreyLightAlt};
  color: ${({ theme }) => theme.colors.colorGreyDark};
  ${({ error, theme }) => error && `border-color: ${theme.colors.colorRed};`}
  display: block;
  height: 40px;
  width: 100%;
  outline: none;
  border-radius: 0px;
  margin-bottom: 10px;
  font-size: 14px;
  padding: 10px;

  @media (max-width: 991px) {
    font-size: 16px;
  }
  ${({ disabled, theme }) => {
    if (disabled) {
      return `
        background-color: ${theme.colors.colorGreyLightAlt};
        color: ${theme.colors.colorGrey};
      `;
    }
    return `
      background-color:  ${theme.colors.colorWhite};
      color: ${theme.colors.colorGreyDark};
      cursor: pointer;
    `;
  }}
`;
